export const tools = [
    {
        name: 'assistant_Usage_get',
        description: "The workspace's assistant usage and cost this month and today, against its plan's limits, per person, with the newest calls.",
        context: 'assistant',
        operationId: 'Usage_get',
        method: 'GET',
        path: '/usage',
        action: 'assistant:read-usage',
        auth: 'tenant',
        inputSchema: {
            type: 'object',
            properties: {},
            required: [],
            additionalProperties: false,
        },
    },
];
//# sourceMappingURL=tools.js.map